import React, {createContext, useReducer, useContext} from 'react'

const MeetingStateContext = createContext()
const MeetingDispatchContext = createContext()

// Meeting Filter state
const initialMeetingState = {
  search: {
    bl_id: '',
    fl_id: '',
    date_start: new Date(),
    date_end: new Date(),
    time_start: '',
    time_end: '',
    capacity: 1,
    resources: [],
    capacityByFloor: null
  }
}

const meetingReducer = (state, action) => {
  switch (action.type) {
    case 'setMeetingSearch':
      return {
        ...state,
        search: {
          ...state.search,
          ...action.payload
        }
      }

    case 'resetMeetingSearch':
      return {
        ...state,
        ...initialMeetingState
      }
  }
}

const MeetingProvider = ({children}) => {
  const [state, dispatch] = useReducer(meetingReducer, initialMeetingState)

  return (
    <MeetingStateContext.Provider value={state}>
      <MeetingDispatchContext.Provider value={dispatch}>
        {children}
      </MeetingDispatchContext.Provider>
    </MeetingStateContext.Provider>
  )
}

const useMeetingState = () => {
  const context = useContext(MeetingStateContext)
  if (context === undefined) {
    throw new Error('useMeetingState must be used within a MeetingProvider')
  }
  return context
}

const useMeetingDispatch = () => {
  const context = useContext(MeetingDispatchContext)

  if (context === undefined) {
    throw new Error('useMeetingDispatch must be used within a MeetingProvider')
  }
  return context
}

export {MeetingProvider, useMeetingState, useMeetingDispatch}
